<div class="tile-padding-first tile-padding">
  <ng-template #utilityBarForm>
    <search (onSearched)="onSearched($event)" [filteredData]="filteredData" [filtersEnabled]="filtersEnabled"
      [autocompleteEnabled]="autocompleteEnabled"></search>
  </ng-template>
  </div>
  <actions-tile [actionDataParams]="actionDataParams" [submissionParams]="submissionParams" (onFiltered)="onFiltered($event)" class="grid-secondary" pageheader="" [currDate]="currDate"  *checkFeatureRender="'ActionsView'"></actions-tile>
